import Vue from 'vue';
const loadMore = Vue.directive('loadMore', {
    priority: 990,
    bind(el, binding) {
        let selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap = selectWrap || el.querySelector('.scroll-loadmore') || el;
        selectWrap.addEventListener("scroll", function (e) {
            const scrollDistance =
                this.scrollHeight - this.scrollTop - this.clientHeight;
            // if (scrollDistance <= 0.5) {
            if (scrollDistance <= 2) {
                binding.value(); //执行在使用时绑定的函数，在这里即loadMorePerson方法
            }
        });
    },
})
export { loadMore }